import {debounce} from '../_functions'
import $ from 'jquery'
import {lockBody, unlockBody} from "../_utils";

document.addEventListener("DOMContentLoaded", function (dom) {
    const trainingDatesList = dom.target.querySelectorAll('.feed-training-date');
    const trainingSelect = dom.target.querySelector('.js-training-select');

    if (trainingDatesList.length && trainingSelect) {
        const filterTrainings = () => {

            trainingDatesList.forEach(post => {
                const postTraining = post.dataset.training || '[]';

                const matchTraining = trainingSelect.value === '' || postTraining === trainingSelect.value;

                if (matchTraining) {
                    post.classList.remove('hidden');
                } else {
                    post.classList.add('hidden');
                }
            });
        };

        trainingSelect.addEventListener('change', filterTrainings);

        filterTrainings();
    }
});

let calendarFiltersOpen = false;

$(document).on('click', '.js-open-calendar-filters', function (e) {
    e.preventDefault();

    $('.js-calendar-filters').slideDown(500);
    $('.js-calendar-overlay').fadeIn(500);

    calendarFiltersOpen = true;
    lockBody();
});

$(document).on('click', '.js-close-calendar-filters, .js-calendar-overlay', function (e) {
    e.preventDefault();

    $('.js-calendar-filters').slideUp(500);
    $('.js-calendar-overlay').fadeOut(500);

    calendarFiltersOpen = false;
    unlockBody();
});

const media = window.matchMedia('(min-width: 992px)');

media.addEventListener('change', function (e) {
    if (e.matches && calendarFiltersOpen) {
        calendarFiltersOpen = false;

        unlockBody();

        $('.js-calendar-overlay').hide();
        $('.js-calendar-filters').removeAttr('style');
    }
});